import { cn } from 'lib/utils'
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from 'primitives/toast'
import { useToast } from 'primitives/use-toast'

export const Toaster = () => {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(({ id, title, icon, description, action, ...props }) => (
        <Toast key={id} {...props}>
          <div
            className={cn('flex flex-col gap-1 min-w-0 flex-1', !title && 'flex-row items-center')}
          >
            {title ? (
              <div className="flex items-center gap-x-2">
                {icon}
                <ToastTitle>{title}</ToastTitle>
              </div>
            ) : (
              icon
            )}
            {description && (
              <ToastDescription className="break-words">{description}</ToastDescription>
            )}
          </div>
          {action}
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  )
}
